import { useTranslation } from 'react-i18next';
import { LOCALE_META, SUPPORTED_LOCALES, normalizeLocale } from '@wikigold/i18n';
import { setAppLocale } from './I18nProvider';

export function LanguagePicker() {
  const { i18n } = useTranslation();
  const current = normalizeLocale(i18n.resolvedLanguage ?? i18n.language);
  return <label className="gold-language-picker">
    <span className="gold-language-icon" aria-hidden="true">◎</span>
    <span className="sr-only">{LOCALE_META[current].englishName}</span>
    <select
      aria-label="Language"
      value={current}
      onChange={event => setAppLocale(normalizeLocale(event.target.value))}
    >
      {SUPPORTED_LOCALES.map(locale => <option key={locale} value={locale}>{LOCALE_META[locale].nativeName}</option>)}
    </select>
  </label>;
}
